'use client'
import React from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import FormError from '../FormError'

export interface ICheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'name'> {
    name?: string
    labelText: React.ReactNode
    error?: string
    register?: UseFormRegisterReturn
}

/**
 * Visual da caixa de marcação pequena do DaisyUI 4 que a loja usava, em utilitários: 20 px, borda fina, marca desenhada por
 * degradês na cor do texto (ou na de erro) e a mesma animação ao marcar.
 */
const CHECKMARK =
    'checked:bg-(--chkbg) checked:bg-no-repeat checked:bg-[image:linear-gradient(-45deg,transparent_65%,var(--chkbg)_65.99%),linear-gradient(45deg,transparent_75%,var(--chkbg)_75.99%),linear-gradient(-45deg,var(--chkbg)_40%,transparent_40.99%),linear-gradient(45deg,var(--chkbg)_30%,var(--chkfg)_30.99%,var(--chkfg)_40%,transparent_40.99%),linear-gradient(-45deg,var(--chkfg)_50%,var(--chkbg)_50.99%)] checked:animate-checkmark'

export const checkboxClass = (hasError: boolean) =>
    `shrink-0 appearance-none cursor-pointer size-5 rounded-[6px] border mr-2 ml-[4px] focus:shadow-none focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:border-0 disabled:border-transparent disabled:bg-base-content disabled:opacity-20 ${CHECKMARK} ${
        hasError
            ? 'border-error [--chkbg:var(--color-error)] [--chkfg:var(--color-error-content)] focus-visible:outline-error checked:border-error checked:text-error-content'
            : 'border-base-content/20 [--chkbg:var(--color-base-content)] [--chkfg:var(--color-base-100)] focus-visible:outline-base-content'
    }`

/** Caixa de marcação com texto ao lado e erro embaixo (padrão do orbit: `register` e `error`). */
const Checkbox: React.FC<ICheckboxProps> = ({ name, labelText, id, className, register, error, ...rest }) => {
    const inputId = id || name || register?.name
    const errorId = `${inputId}-error`
    return (
        <div className={`flex form-group pb-2 ${className ?? ''}`}>
            <label htmlFor={inputId} className="flex content-start">
                <input
                    name={name}
                    {...register}
                    className={checkboxClass(Boolean(error))}
                    type="checkbox"
                    id={inputId}
                    aria-invalid={error ? true : undefined}
                    aria-describedby={error ? errorId : undefined}
                    {...rest}
                />
                {labelText}
            </label>
            <FormError id={errorId}>{error}</FormError>
        </div>
    )
}

export default Checkbox
